<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="_width" :height="_height" :spin="spin" :rtl="rtl" viewBox="0 0 1024 1024" preserveAspectRatio="xMidYMid meet" fill="" role="presentation" ref="host">
    <g>
      <path data-follow-fill="currentColor" d="M907 271zm-27.2 56v-.5c-1.4-6.7-4.7-12.8-9.5-17.2-5.2-4.8-11.5-7.3-18.2-7.3H698v-40.5c0-49.8-19.6-96.6-55-132-35.3-35.5-82.2-55-132-55s-96.5 19.5-132 55c-35.4 35.4-54.9 82.3-54.9 132V302H170c-13.1 0-24.8 10.3-27.6 24.5l-.1.2-45.5 591.5v2.4c0 16.3 11.4 27.7 27.7 27.7l773 .1c16.3 0 27.7-11.4 27.7-27.7v-2.5L879.8 327zm-500-65.7c0-72.5 58.9-131.4 131.4-131.4s131.4 58.9 131.4 131.4v40.5H379.8v-40.5zM155.2 893l1.2-12.7L162 802h-.4l5.5-73.6 28-371.1h632L855.2 735v.2l12.2 140 1.8 17.8h-714z" :fill="_fill" />
      <g data-follow-fill="currentColor" :fill="_fill">
        <path d="M699.5 499.6c10.8 10.8 10.8 28.3 0 39.1L519.3 718.8l-19.6 19.6c-10.8 10.8-28.3 10.8-39.1 0s-10.8-28.3 0-39.1l19.6-19.6 180.1-180.1c10.8-10.8 28.4-10.8 39.2 0z" />
        <path d="M499.8 738.3c-10.8 10.8-28.3 10.8-39.1 0l-19.6-19.6-92.1-92.1c-10.8-10.8-10.8-28.3 0-39.1s28.3-10.8 39.1 0l92.2 92.2 19.6 19.5c10.7 10.8 10.7 28.3-.1 39.1z" />
      </g>
    </g>
  </svg>
</template>

<script setup>
import { ref, computed, onMounted, onUpdated } from 'vue';
const props = defineProps({
  width: {
    type: [Number, String],
    required: false
  },
  height: {
    type: [Number, String],
    required: false
  },
  stroke: {
    type: String,
    required: false
  },
  fill: {
    type: String,
    required: false
  },
  color: {
    type: String,
    required: false
  },
  spin: {
    type: Boolean,
    required: false
  },
  rtl: {
    type: Boolean,
    required: false
  }
});
const size = '1em';

const _fill = computed(() => props.fill || props.color || undefined);
const _stroke = computed(() => props.stroke || props.color || undefined);
const _width = computed(() => props.width || size || undefined);
const _height = computed(() => props.height || size || undefined);
const host = ref(null);

onMounted(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
onUpdated(() => {
  if (!_fill.value) {
    host.value?.querySelectorAll('[data-follow-fill]').forEach((item) => {
      item.setAttribute('fill', item.getAttribute('data-follow-fill') || '');
    });
  }
  if (!_stroke.value) {
    host.value?.querySelectorAll('[data-follow-stroke]').forEach((item) => {
      item.setAttribute('stroke', item.getAttribute('data-follow-stroke') || '');
    });
  }
});
</script>

<style scoped>
svg[spin='true'] {
  animation: iconpark-spin 1s infinite linear;
}

svg[spin='true'][rtl='true'] {
  animation: iconpark-spin-rtl 1s infinite linear;
}

svg[rtl='true'] {
  transform: scaleX(-1);
}
@keyframes iconpark-spin {
  0% {
    -webkit-transform: rotate(0);
    transform: rotate(0);
  }

  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes iconpark-spin-rtl {
  0% {
    -webkit-transform: scaleX(-1) rotate(0);
    transform: scaleX(-1) rotate(0);
  }

  100% {
    -webkit-transform: scaleX(-1) rotate(360deg);
    transform: scaleX(-1) rotate(360deg);
  }
}
</style>
